module.exports = __webpack_public_path__ + "static/media/dm-valjevo-logo.fd18c7e1.svg";